import { createI18n } from 'vue-i18n';
import th from './lang/th.json';
import en from './lang/en.json';

// Type-define 'th' as the master schema for the resource
type MessageSchema = typeof th;

const i18n = createI18n<[MessageSchema], 'TH' | 'EN'>({
  legacy: false,
  locale: 'TH',
  fallbackLocale: 'TH',
  messages: {
    'TH': th,
    'EN': en,
  },
});

export default i18n;
